import React, { PropsWithChildren } from "react";

import { cn } from "@/utils/cn";

interface ITagProps extends PropsWithChildren {
	color?: string;
	className?: string;
}

export const Tag: React.FC<ITagProps> = ({ children, color, className }) => {
	return (
		<span
			className={cn([
				"text-2xs overflow-hidden rounded-3xl px-2 py-1 text-ellipsis whitespace-nowrap text-white",
				className,
			])}
			style={{
				backgroundColor: color,
			}}
		>
			{children}
		</span>
	);
};
